// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikSelect } from "src/components/Forms/Select";
import { genders } from "src/constants/influencer";
import { FormikProps } from "formik";
import ClearButton from "./ClearButton";
import { Box } from "src/components/Core/Box";

interface Props {
  formProps: FormikProps<any>;
  clearFilterKey: (key: string) => void;
}

const Gender: React.FC<Props> = ({ formProps, clearFilterKey }) => {
  let gender = formProps?.values?.influencerGender;
  let isVisible = false;
  let backgroundColor = "#FFFFFF";

  if (gender !== "") {
    isVisible = true;
    backgroundColor = "#FAFAFA";
  }

  return (
    <Box background={backgroundColor} padding="5px">
      <Field
        label="Gender:"
        mb={20}
        extra={
          <ClearButton
            isVisible={isVisible}
            buttonClick={() => {
              formProps?.setFieldValue("influencerGender", "");
              clearFilterKey("influencerGender");
            }}
          />
        }
      >
        <FormikSelect
          name="influencerGender"
          data={genders}
          local
          borderRadius={3}
          borderColor="grey5"
          size="middle"
        />
      </Field>
    </Box>
  );
};

export default Gender;
